import axios from 'axios';

// Wait for DOM.
$(() =>
{
    if ($('html').hasClass('isLocal')) {
        return;
    }

    // Get website page id.
    let statisticData = JSON.parse(document.documentElement.getAttribute('data-website-statistic-poster') || 'false');

    // Let server know about pageview?
    if (!statisticData)
        return;

    // Give it some time to load the page resources first.
    setTimeout(() =>
    {
        // Init form data.
        const formData = new FormData();

        for(let prop in statisticData)
            formData.append(prop, statisticData[prop]);

        // Post
        axios.post('/vendor/galaxy/website/statistics.php', formData);

    }, 500);

});
